import { Component } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { WidgetService } from '../../services/widget.service';
import { AuthService } from '../../services/auth.service';
import { ValidationService } from '../../services/validation/validation.service';
import { ToastService } from '../../services/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Tab } from 'bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-widgets',
  templateUrl: './custom-widgets.component.html',
  styleUrl: './custom-widgets.component.scss',
})
export class CustomWidgetsComponent {
  search: any;
  dynamicPlaceholder: string = 'Search widget';
  user: any;
  employeeId: any;
  data: any = [
    {
      id: 1,
      company_id: 1,
      location_id: 1,
      widget_name: 'Leave',
      position: 1,
      alignment: 2,
      user_group: 1,
      is_parent: 0,
      parent_id: 1,
      createdby: null,
      updatedby: null,
    },
  ];

  headerColor: string[] = [
    '#707586',
    '#2F6EF4',
    '#29B05D',
    '#8164F3',
    '#E93956',
    '#F76832',
    '#ECAF11',
    '#44BEDC',
  ];
  sidemenuColor: string[] = [
    '#707586',
    '#2F6EF4',
    '#29B05D',
    '#8164F3',
    '#E93956',
    '#F76832',
    '#ECAF11',
    '#44BEDC',
  ];
  sidemenuActiveColor: string[] = [
    '#707586',
    '#2F6EF4',
    '#29B05D',
    '#8164F3',
    '#E93956',
    '#F76832',
    '#ECAF11',
    '#44BEDC',
  ];
  hoverColor: string[] = [
    '#707586',
    '#2F6EF4',
    '#29B05D',
    '#8164F3',
    '#E93956',
    '#F76832',
    '#ECAF11',
    '#44BEDC',
  ];

  leftWidgets: any[] = [];
  middleWidgets: any[] = [];
  rightWidgets: any[] = [];
  company: any;
  location: any;
  widgetForm!: FormGroup;
  colorpalletteForm!: FormGroup;
  submit = false;
  finalWidgetsList: any[] = [];
  widgetObject: any;
  pickerFlag: boolean = false;
  customWidget: any;
  alignedWidget: any;

  sidebarFlag: boolean = false;
  headerFlag: boolean = false;
  sidebarActiveFlag: boolean = false;
  hoverFlag: Boolean = false;

  // Set theme color
  bg_text_color: any;
  bg_color: any;
  sidebar_text_color: any;
  sidebar_color: any;
  link_active_bg_color: any;
  link_active_text_color: any;
  title_color: any;
  link_hover_bg_color: any;
  link_hover_text_color: any;
  selectedHeaderColor: string = "";
  selectedSidebarColor: string = "";

  filteredElements: any[] = [];

  moduleList = [
    { id: 1, name: 'Leave' },
    { id: 2, name: 'Payroll & Compensation' },
    { id: 3, name: 'Travel & Expenses' },
    { id: 4, name: 'Productivity Widgets' },
  ];

  elementList = [
    { id: 101, module_id: 1, name: 'Leave History' },

    { id: 102, module_id: 2, name: 'Payslip Download' },
    { id: 103, module_id: 2, name: 'Reimbursement Tracker' },

    { id: 104, module_id: 3, name: 'Travel Requests' },

    { id: 105, module_id: 4, name: 'Task List / To-Do' },
  ];

  constructor(private readonly widgetservice: WidgetService, private readonly authservice: AuthService,
    private readonly validation: ValidationService, private readonly fb: FormBuilder, private readonly toast: ToastService,
    private readonly modalService: NgbModal, private router: Router
  ) { }

  isShowWidget: boolean = false;
  ngOnInit() {
    this.colorpalletteForm = this.fb.group({
      type: [''],
      bg_color: [''],
      bg_text_color: [''],
      sidebar_color: [''],
      sidebar_text_color: [''],
      link_active_bg_color: [''],
      link_active_text_color: [''],
      title_color: [''],
      link_hover_text_color: [''],
      link_hover_bg_color: [''],
    });

    this.authservice.user.subscribe((data) => {
      if (data.role_type == 'super_user' || data.role_type == 'employee') {
        this.isShowWidget = true;
        this.getWidget();
      } else {
        this.isShowWidget = false;
        const triggerEl = document.querySelector('#pills-contact-tab');
        if (triggerEl) {
          const tab = new Tab(triggerEl);
          tab.show();
        }
      }
    });

    this.widgetForm = new FormGroup({
      id: new FormControl(null),
      // widget_name: new FormControl('', [
      //   Validators.required,
      //   Validators.minLength(3),
      //   Validators.maxLength(100),
      //   Validators.pattern(this.validation.lettersandsinglespace),
      // ]),
      widget_name: new FormControl(''),
      module: new FormControl('', Validators.required),
      elements: new FormControl('', Validators.required),
      alignment: new FormControl('', [
        Validators.required,
        Validators.min(1),
        Validators.max(100000),
        Validators.pattern(this.validation.allowNumber),
      ]),
      position: new FormControl('', Validators.required),
    });

    this.widgetForm.get('elements')?.valueChanges.subscribe((elementId) => {
      if (elementId) {
        const selectedElement = this.elementList.find(e => e.id == elementId);
        if (selectedElement) {
          this.widgetForm.get('widget_name')?.setValue(selectedElement.name, { emitEvent: false });
        }
      } else {
        this.widgetForm.get('widget_name')?.reset('', { emitEvent: false });
      }
    });

    this.widgetForm.get('module')?.valueChanges.subscribe((moduleId) => {
      if (moduleId == 1 || moduleId == 2 || moduleId == 3) {
        this.widgetForm.get('position')?.setValue(2, { emitEvent: false }); // Middle
      } else if (moduleId == 4) {
        this.widgetForm.get('position')?.setValue(3, { emitEvent: false }); // Right
      } else {
        this.widgetForm.get('position')?.reset(null, { emitEvent: false });
      }
    });



    const dataString: string | null = localStorage.getItem('auth_user');

    if (dataString) {
      const data = JSON.parse(dataString);

      this.company = data.companyID;
      this.location = data.locationID;
      this.user = data.group_id;
      this.employeeId = data.userID;
    }

    const jsonColor = localStorage.getItem('color');
    if (jsonColor) {
      const data = JSON.parse(jsonColor);
      this.colorpalletteForm.patchValue({
        type: data?.type,
        bg_color: data?.bg_color,
        bg_text_color: data?.bg_text_color,
        sidebar_color: data?.sidebar_color,
        sidebar_text_color: data?.sidebar_text_color,
        link_active_bg_color: data?.link_active_bg_color,
        link_active_text_color: data?.link_active_text_color,
        title_color: data?.title_color,
        link_hover_text_color: data?.link_hover_text_color,
        link_hover_bg_color: data?.link_hover_bg_color,
      });
      this.bg_text_color = data.bg_text_color || '#ffffff';
      this.bg_color = data.bg_color || '#2A9D8E';
      this.sidebar_text_color = data.sidebar_text_color || '#ffffff';
      this.sidebar_color = data.sidebar_color || '#2f4050';
      this.link_active_bg_color = data?.link_active_bg_color || '#e0e0e0';
      this.link_active_text_color = data?.link_active_text_color || '#006fc2';
      this.title_color = data?.title_color || '#000000';
      this.link_hover_text_color = data?.link_hover_text_color || '#006fc2';
      this.link_hover_bg_color = data?.link_hover_bg_color || '#e0e0e0';
    } else {
      this.bg_text_color = '#ffffff';
      this.bg_color = '#2A9D8E';
      this.sidebar_text_color = '#ffffff';
      this.sidebar_color = '#2f4050';
      this.link_active_bg_color = '#e0e0e0';
      this.link_active_text_color = '#e0e0e0';
      this.title_color = '#000000';
      this.link_hover_bg_color = '#e0e0e0';
      this.link_hover_text_color = '#006fc2';
    }

    if (jsonColor) {
      // ...your existing patchValue logic...
      this.selectedHeaderColor = (this.data.bg_color || '#2A9D8E').toLowerCase();
      this.selectedSidebarColor = (this.data.sidebar_color || '#2f4050').toLowerCase();
    } else {
      this.selectedHeaderColor = '#2A9D8E';
      this.selectedSidebarColor = '#2f4050';
    }

    this.widgetForm.get('module')?.valueChanges.subscribe((moduleId) => {
      this.filteredElements = this.elementList.filter(e => e.module_id == moduleId);
      this.widgetForm.get('elements')?.setValue('');
    });
  }

  private normalizeColorArg(arg: any): string {
    if (!arg) { return ''; }
    if (typeof arg === 'string') { return arg.trim().toLowerCase(); }
    // <input type="color"> change event
    const v = arg?.target?.value;
    return (typeof v === 'string' ? v.trim().toLowerCase() : '').toLowerCase();
  }

  get form() {
    return this.widgetForm?.controls;
  }

  async getWidget() {
    await this.getCustomWidgets();
    await this.getAlignedWidgets();
    this.getAllWidgets();
  }

  async getCustomWidgets(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.widgetservice.getAllCustomWidgetList().subscribe({
        next: (res) => {
          this.customWidget = res.data;
          resolve();
        },
        error: (err) => {
          console.log(err);
          reject(err);
        },
      });
    });
  }

  //get aligned widgets from alignedwidgetstable by employee_id
  getAlignedWidgets(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.widgetservice.getAlignedWidgetList(this.employeeId).subscribe({
        next: (res) => {
          const matchedGroup = res?.data?.[0]?.widgets ?? [];
          this.alignedWidget = Array.isArray(matchedGroup) ? matchedGroup : [];
          resolve();
        },
        error: (err) => {
          console.log(err);
          this.alignedWidget = []; // Fallback in case of error
          reject(err);
        },
      });
    });
  }

  async getAllWidgets() {

    await this.getCustomWidgets();
    await this.getAlignedWidgets();

    this.leftWidgets = [];
    this.middleWidgets = [];
    this.rightWidgets = [];
    this.data = [];

    if (this.alignedWidget.length > 0) {
      const aligned = this.alignedWidget.map((item: any, index: number) => {
        const isDefault =
          item.hasOwnProperty('type') && item.type === 'default';

        return {
          ...item,
          type: isDefault ? 'default' : 'custom',
          // checked: isDefault,
          // disabled: isDefault,
          alignment: item.alignment || index + 1,
        };
      });

      this.data = aligned;

      this.leftWidgets = aligned
        .filter((item: any) => item.position === 1)
        .sort((a: any, b: any) => a.alignment - b.alignment);

      this.middleWidgets = aligned
        .filter((item: any) => item.position === 2)
        .sort((a: any, b: any) => a.alignment - b.alignment);

      this.rightWidgets = aligned
        .filter((item: any) => item.position === 3)
        .sort((a: any, b: any) => a.alignment - b.alignment);

      // console.log('Left Widgets:', this.leftWidgets);
      // console.log('Middle Widgets:', this.middleWidgets);
      //console.log('Right Widgets:', this.rightWidgets);
    } else {
      this.widgetservice.getAllWidgetUserGroupList(this.user).subscribe({
        next: (res) => {
          const dataArray = res.data;

          // Step 1: Prepare all default widgets with checked = true and disabled = true
          this.data = dataArray.map((item: any) => ({
            ...item,
            checked: true, // Default widgets are checked
            type: 'default'
          }));

          this.leftWidgets = [
            ...this.data.filter((item: any) => item.position === 1),
            ...this.customWidget.filter((item: any) => item.position === 1).map((item: any) => ({
              ...item,
              checked: false,
              type: 'custom',
            }))
          ].sort((a: any, b: any) => a.alignment - b.alignment);

          this.middleWidgets = [
            ...this.data.filter((item: any) => item.position === 2),
            ...this.customWidget.filter((item: any) => item.position === 2).map((item: any) => ({
              ...item,
              checked: false,
              type: 'custom',
            }))
          ].sort((a: any, b: any) => a.alignment - b.alignment);

          this.rightWidgets = [
            ...this.data.filter((item: any) => item.position === 3),
            ...this.customWidget.filter((item: any) => item.position === 3).map((item: any) => ({
              ...item,
              checked: false,
              type: 'custom',
            }))
          ].sort((a: any, b: any) => a.alignment - b.alignment);

          // console.log('Left Widgets:', this.leftWidgets);
          // console.log('Middle Widgets:', this.middleWidgets);
          // console.log('Right Widgets:', this.rightWidgets);
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }

  searchTable(event: any) {
    this.search = (event.target as HTMLInputElement).value;
  }

  drop(event: CdkDragDrop<any[]>, column: 'left' | 'middle' | 'right') {
    let containerArray;

    switch (column) {
      case 'left':
        containerArray = this.leftWidgets;
        break;
      case 'middle':
        containerArray = this.middleWidgets;
        break;
      case 'right':
        containerArray = this.rightWidgets;
        break;
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(containerArray, event.previousIndex, event.currentIndex);
    } else {
      return;
    }

    containerArray.forEach((item, index) => {
      item.alignment = index + 1;
      item.position = column === 'left' ? 1 : column === 'middle' ? 2 : 3;
    });

    this.updateFinalWidgetsList();
  }

  updateFinalWidgetsList() {
    this.finalWidgetsList = [];

    [...this.leftWidgets, ...this.middleWidgets, ...this.rightWidgets].forEach(
      (item) => {
        //console.log("lala",item)
        this.finalWidgetsList.push({
          id: item.id,
          widget_name: item.widget_name,
          position: item.position,
          alignment: item.alignment,
          checked: item.checked === true,
          type: item.type || 'default', // Fallback to 'default' if type is missing
        });
      },
    );

    this.widgetObject = {
      employee_id: this.employeeId,
      user_group: this.user,
      company_id: this.company,
      location_id: this.location,
      widgets: this.finalWidgetsList,
    };
    // console.log('Live updated list:', this.widgetObject);
  }

  sidebarColor(colorArg: any) {
    // if (typeof (color) == 'object') {
    //   // document.documentElement.style.setProperty('--sidebar-color', color?.target?.value);
    //   this.colorpalletteForm.get('sidebar_color')?.setValue(color?.target?.value);
    //   this.sidebar_color = color?.target?.value;
    // }
    // else {
    //   // document.documentElement.style.setProperty('--sidebar-color', color);
    //   this.colorpalletteForm.get('sidebar_color')?.setValue(color);
    //   this.sidebar_color = color;
    // }
    // const color = this.normalizeColorArg(colorArg) || this.sidebar_color;
    // this.selectedSidebarColor = color;
    // this.sidebar_color = color;
    // this.colorpalletteForm.get('sidebar_color')?.setValue(color);
    const color = this.normalizeColorArg(colorArg) || this.sidebar_color;

    if (this.selectedSidebarColor === color.toLowerCase()) {
      // Unselect if same color clicked again
      this.selectedSidebarColor = '';
      this.sidebar_color = '';
      this.colorpalletteForm.get('sidebar_color')?.setValue('');
    } else {
      // Select new color
      this.selectedSidebarColor = color.toLowerCase();
      this.sidebar_color = color;
      this.colorpalletteForm.get('sidebar_color')?.setValue(color);
    }
  }

  sidebarTextcolor(event: any) {
    // document.documentElement.style.setProperty('--sidebar-text-color', event.target.value);
    this.colorpalletteForm.get('sidebar_text_color')?.setValue(event.target.value);
  }

  getheaderColor(colorArg: any) {
    // if (typeof (color) == 'object') {
    //   // document.documentElement.style.setProperty('--header-color', color?.target?.value);
    //   this.colorpalletteForm.get('type')?.setValue('default');
    //   this.colorpalletteForm.get('bg_color')?.setValue(color?.target?.value);
    //   this.bg_color = color?.target?.value;
    // }
    // else {
    //   // document.documentElement.style.setProperty('--header-color', color);
    //   this.colorpalletteForm.get('type')?.setValue('default');
    //   this.colorpalletteForm.get('bg_color')?.setValue(color);
    //   this.bg_color = color;
    // }
    // const color = this.normalizeColorArg(colorArg) || this.bg_color;
    // this.selectedHeaderColor = color;
    // this.bg_color = color;
    // this.colorpalletteForm.get('type')?.setValue('default');
    // this.colorpalletteForm.get('bg_color')?.setValue(color);
    const color = this.normalizeColorArg(colorArg) || this.bg_color;

    if (this.selectedHeaderColor === color.toLocaleLowerCase()) {
      // Unselect if same color clicked again
      this.selectedHeaderColor = '';
      this.bg_color = '';
      this.colorpalletteForm.get('type')?.setValue('');
      this.colorpalletteForm.get('bg_color')?.setValue('');
    } else {
      // Select new color
      this.selectedHeaderColor = color.toLocaleLowerCase();
      this.bg_color = color;
      this.colorpalletteForm.get('type')?.setValue('default');
      this.colorpalletteForm.get('bg_color')?.setValue(color);
    }
  }

  getHeadertextcolor(event: any) {
    // document.documentElement.style.setProperty(
    //   '--header-text-color',
    //   event.target.value,
    // );
    this.colorpalletteForm.get('bg_text_color')?.setValue(event.target.value);
  }

  linkActiveBgColor(event: any) {
    // console.log(event?.target?.value, event);
    if (typeof event == 'object') {
      // document.documentElement.style.setProperty('--link-active-bg-color', event?.target?.value);
      this.colorpalletteForm
        .get('link_active_bg_color')
        ?.setValue(event?.target?.value);
      this.link_active_bg_color = event?.target?.value;
    } else {
      // document.documentElement.style.setProperty(
      //   '--link-active-bg-color',
      //   event,
      // );
      this.colorpalletteForm.get('link_active_bg_color')?.setValue(event);
      this.link_active_bg_color = event;
    }
  }

  linkActiveTextColor(event: any) {
    // document.documentElement.style.setProperty(
    //   '--link-active-text-color',
    //   event.target.value,
    // );
    this.colorpalletteForm
      .get('link_active_text_color')
      ?.setValue(event.target.value);
  }

  titleColor(event: any) {
    // document.documentElement.style.setProperty(
    //   '--title-color',
    //   event.target.value,
    // );
    this.colorpalletteForm.get('title_color')?.setValue(event.target.value);
  }

  hoverBgColor(event: any) {
    if (typeof event == 'object') {
      // document.documentElement.style.setProperty(
      //   '--link-hover-bg-color',
      //   event?.target?.value,
      // );
      this.colorpalletteForm
        .get('link_hover_bg_color')
        ?.setValue(event?.target?.value);
      this.link_active_bg_color = event?.target?.value;
    } else {
      document.documentElement.style.setProperty(
        '--link-hover-bg-color',
        event,
      );
      this.colorpalletteForm.get('link_hover_bg_color')?.setValue(event);
      this.link_active_bg_color = event;
    }
  }

  hoverTextColor(event: any) {
    // document.documentElement.style.setProperty('--link-hover-text-color', event.target.value);
    this.colorpalletteForm.get('link_hover_text_color')?.setValue(event.target.value);
  }

  sidebarPicker() {
    this.sidebarFlag = !this.sidebarFlag;
  }

  activeSidebarPicker() {
    this.sidebarActiveFlag = !this.sidebarActiveFlag;
  }

  headerPicker() {
    this.headerFlag = !this.headerFlag;
  }

  hoverPicker() {
    this.hoverFlag = !this.hoverFlag;
  }

  colorpalletteSubmit() {
    this.colorpalletteForm.patchValue({
      bg_color: this.bg_color,
      bg_text_color: this.bg_text_color,
      link_active_bg_color: this.link_active_bg_color,
      link_active_text_color: this.link_active_text_color,
      link_hover_bg_color: this.link_hover_bg_color,
      link_hover_text_color: this.link_hover_text_color,
      sidebar_color: this.sidebar_color,
      sidebar_text_color: this.sidebar_text_color,
      title_color: this.title_color,
      type: 'default',
    });
    //console.log(this.colorpalletteForm.value);
    const jsonColor = localStorage.getItem('color');
    if (jsonColor) {
      const jsonData = JSON.parse(jsonColor);
      this.widgetservice.update(this.colorpalletteForm.value, jsonData?.id).subscribe({
        next: resp => {
          this.toast.success(resp?.message);
          localStorage.setItem('color', JSON.stringify(resp?.data));
          this.modalService.dismissAll();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
        error: err => {
          console.log(err.error.message);
        }
      })
    }
    else {
      this.widgetservice.add(this.colorpalletteForm.value).subscribe({
        next: (resp) => {
          this.toast.success(resp?.message);
          localStorage.setItem('color', JSON.stringify(resp?.data));
          this.modalService.dismissAll();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
        error: (err) => {
          console.log(err.error.message);
        },
      });
    }
  }

  storeDefaultWidget() {
    this.updateFinalWidgetsList();
    this.widgetservice.saveWidget(this.widgetObject).subscribe({
      next: (res) => {
        this.getAllWidgets();
      },
      error: (err) => {
        this.toast.failure(err?.message);
      },
    });
  }

  submitWidgets() {
    this.updateFinalWidgetsList();
    this.widgetservice.saveWidget(this.widgetObject).subscribe({
      next: (res) => {
        this.toast.success(res?.message);
        this.getAllWidgets();

        this.modalService.dismissAll();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      error: (err) => {
        this.toast.failure(err?.message);
      },
    });
  }

  // submitWidgets() {
  //   if (!this.fullWidgetList || !Array.isArray(this.fullWidgetList)) {
  //     console.error("Invalid or empty fullWidgetList");
  //     return;
  //   }

  //   if (!this.widgetObject?.widgets) {
  //     console.error("Invalid widgetObject structure");
  //     return;
  //   }

  //   // Step 1: Extract fullWidgetList safely and clean structure
  //   const cleanedFullWidgetList = this.fullWidgetList.map((e: any) => ({
  //     widget_name: e.widget_name,
  //     id: e.id,
  //     position: e.position,
  //     alignment: e.alignment,
  //     checked: e.checked
  //   }));

  //   // Step 2: Separate existing widgets by type
  //   const allWidgets = this.widgetObject.widgets;
  //   const defaultWidgets = allWidgets.filter((w: any) => w.type === 'default');
  //   const otherWidgets = allWidgets.filter((w: any) => w.type !== 'default');

  //   // Step 3: Find missing widgets not already in defaultWidgets
  //   const existingIds = new Set(defaultWidgets.map((w: any) => w.id));
  //   const missingWidgets = cleanedFullWidgetList.filter((w: any) => !existingIds.has(w.id));

  //   // Add the missing widgets to the defaultWidgets list
  //   defaultWidgets.push(...missingWidgets.map((widget) => ({
  //     ...widget,
  //     type: 'default'  // explicitly ensure type is default
  //   })));

  //   // Step 4: Get the highest alignment value from otherWidgets
  //   const maxAlignmentOther = Math.max(
  //     0,
  //     ...otherWidgets.map((w: any) => Number(w.alignment) || 0)
  //   );

  //   // Step 5: Assign new incremental alignment starting after maxAlignmentOther
  //   defaultWidgets.forEach((widget: any, index: number) => {
  //     widget.alignment = maxAlignmentOther + index + 1;
  //   });

  //   // Step 6: Re-assign updated widgets array back to widgetObject
  //   this.widgetObject.widgets = [...otherWidgets, ...defaultWidgets];

  //   // Step 7: Save
  //   this.widgetservice.saveWidget(this.widgetObject).subscribe({
  //     next: (res) => {
  //       this.toast.success(res?.message || 'Widget saved successfully');
  //       this.getAllWidgets();
  //     },
  //     error: (err) => {
  //       console.error("Widget save error:", err);
  //       this.toast.failure(err?.message || 'Failed to save widgets');
  //     },
  //   });
  // }

  onSubmit() {
    this.submit = true;
    if (this.widgetForm.valid) {
      // console.log('Form Submitted:', this.widgetForm.value);
      if (this.alignedWidget.length > 0) {
        const widgets = {
          ...this.widgetForm.value,
          user_group: this.user,
          employee_id: this.employeeId,
        };
        let apiCall;

        if (widgets.id !== '' && widgets.id !== null) {
          apiCall = this.widgetservice.updateCustomWidget(widgets, widgets.id);
        } else {
          apiCall = this.widgetservice.saveCustomWidget(widgets);
        }

        apiCall.subscribe({
          next: (res) => {
            this.toast.success(res?.message);
            this.widgetForm.reset();

            Object.keys(this.widgetForm.controls).forEach((key) => {
              const control = this.widgetForm.get(key);
              if (control) {
                control.setErrors(null);
                control.markAsPristine();
                control.markAsUntouched();
              }
            });

            this.widgetForm.updateValueAndValidity();

            const tabTriggerEl = document.querySelector('#pills-home-tab');
            if (tabTriggerEl) {
              const tab = new Tab(tabTriggerEl);
              tab.show();
              this.getWidget();
            }
          },
          error: (err) => {
            this.toast.failure(err?.message);
          },
        });
      } else {
        this.toast.failure('Please contact admin to add default widgets. Then You can add custom widgets.');
      }
    }
  }

  onCancel() {
    this.widgetForm.reset();
    this.isEditCustomWidget = false;
    Object.keys(this.widgetForm.controls).forEach((key) => {
      const control = this.widgetForm.get(key);
      if (control) {
        control.markAsPristine();
        control.markAsUntouched();
        this.widgetForm.updateValueAndValidity();
      }
    });
    this.modalService.dismissAll();
  }

  resetTheme() {
    Swal.fire({
      title: 'Do you want to Reset the Theme Color?',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('color');
        document.documentElement.style.setProperty('--header-color', '#2A9D8E');
        document.documentElement.style.setProperty(
          '--header-text-color',
          '#ffffff',
        );
        document.documentElement.style.setProperty(
          '--sidebar-text-color',
          '#ffffff',
        );
        document.documentElement.style.setProperty(
          '--sidebar-color',
          '#2f4050',
        );
        document.documentElement.style.setProperty(
          '--link-active-bg-color',
          '#e0e0e0',
        );
        document.documentElement.style.setProperty(
          '--link-active-text-color',
          '#006fc2',
        );
        document.documentElement.style.setProperty('--title-color', '#000000');
        document.documentElement.style.setProperty(
          '--link-hover-bg-color',
          '#e0e0e0',
        );
        document.documentElement.style.setProperty(
          '--link-hover-text-color',
          '#006fc2',
        );
        this.modalService.dismissAll();
        window.location.reload();
      } else {
        this.modalService.dismissAll();
      }
    });
  }

  // clear() {
  //   const jsonColor = localStorage.getItem('color');
  //   if (jsonColor) {
  //     const data = JSON.parse(jsonColor);
  //     this.colorpalletteForm.patchValue({
  //       type: data?.type,
  //       bg_color: data?.bg_color,
  //       bg_text_color: data?.bg_text_color,
  //       sidebar_color: data?.sidebar_color,
  //       sidebar_text_color: data?.sidebar_text_color,
  //       link_active_bg_color: data?.link_active_bg_color,
  //       link_active_text_color: data?.link_active_text_color,
  //       title_color: data?.title_color
  //     })
  //     this.bg_text_color = data.bg_text_color || '#ffffff';
  //     this.bg_color = data.bg_color || '#2A9D8E';
  //     this.sidebar_text_color = data.sidebar_text_color || '#ffffff';
  //     this.sidebar_color = data.sidebar_color || '#2f4050';
  //     this.link_active_bg_color = data?.link_active_bg_color || '#e0e0e0';
  //     this.link_active_text_color = data?.link_active_text_color || '#e0e0e0';
  //     this.title_color = data?.title_color || '#000000';
  //   }
  // }
  isEditCustomWidget: boolean = false;
  onEditWidget(widget: any): void {
    // console.log('Edit widget:', widget);
    this.isEditCustomWidget = true;
    const editwidget = this.customWidget.find((x: any) => x.id === widget.id);
    // console.log('editwidget', editwidget);
    this.widgetForm.patchValue({
      widget_name: editwidget.widget_name,
      module: editwidget.module,
      elements: editwidget.elements,
      alignment: editwidget.alignment,
      position: editwidget.position,
      id: editwidget.id,
    });

    const tabTriggerEl = document.querySelector('#pills-profile-tab');
    if (tabTriggerEl) {
      const tab = new Tab(tabTriggerEl);
      tab.show();
    }
  }
}
